export function cleanV2FilterPayload(filter: any): any {
  for (const key of Object.keys(filter)) {
    const value = filter[key];

    if (typeof value === 'string' && value.trim() === '') {
      filter[key] = null;
      continue;
    }

    if (Array.isArray(value)) {
      filter[key] = value.filter(entry => !(typeof entry === 'string' && entry.trim() === '') && entry != null);
      continue;
    }

    if (isInvalidLocalDatePayload(value)) {
      filter[key] = null;
    }
  }

  return filter;
}

function isInvalidLocalDatePayload(value: any): boolean {
  if (!value || typeof value !== 'object') {
    return false;
  }

  if (!('year' in value) || !('month' in value) || !('day' in value)) {
    return false;
  }

  return !isValidDatePart(value.year)
    || !isValidDatePart(value.month)
    || !isValidDatePart(value.day)
    || value.month < 1
    || value.month > 12
    || value.day < 1
    || value.day > 31;
}

function isValidDatePart(value: any): boolean {
  return typeof value === 'number' && Number.isFinite(value);
}
